import React from "react";
import { useBrandingColors } from "../../hooks/useBrandingColors";
import { FilePdf2LineIconV7 } from "./figma-icons-v7";

export interface DownloadPdfButtonProps {
  onClick: () => void;
  label?: string;
  className?: string;
  disabled?: boolean;
  size?: 'default' | 'compact' | 'medium';
  icon?: React.ReactNode | null;
}

export const DownloadPdfButton: React.FC<DownloadPdfButtonProps> = ({
  onClick,
  label = "Скачать PDF",
  className,
  disabled,
  size = 'default',
  icon,
}) => {
  const colors = useBrandingColors();
  const isCompact = size === 'compact';
  const isMedium = size === 'medium';

  const paddingClass = isCompact ? 'px-2.5 py-2' : isMedium ? 'px-3 py-2.5' : 'px-3 py-2';
  const textSizeClass = isCompact ? 'text-[14px]' : isMedium ? 'text-[14px]' : 'text-[15px]';
  const lineHeightClass = isCompact ? 'leading-[20px]' : isMedium ? 'leading-[20px]' : 'leading-[24px]';
  const iconSize = isCompact ? 20 : isMedium ? 20 : 24;
  const resolvedIcon = icon === undefined ? <FilePdf2LineIconV7 size={iconSize} color={colors.primary} /> : icon;

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`bg-[#ffffff] relative rounded-2xl shrink-0 hover:bg-[#f6f8fa] transition-colors cursor-pointer disabled:opacity-60 disabled:cursor-not-allowed ${className || ""}`}
    >
      <div className={`box-border content-stretch flex flex-row gap-1 items-center justify-center overflow-clip relative ${paddingClass}`}>
        <div className="box-border content-stretch flex flex-row gap-2 items-center justify-center px-1 py-0 relative shrink-0">
          <div
            className={`font-inter font-normal leading-[0] not-italic relative shrink-0 ${textSizeClass} text-center text-nowrap`}
            style={{ color: colors.primary }}
          >
            <p className={`adjustLetterSpacing block whitespace-pre ${lineHeightClass}`}>{label}</p>
          </div>
          {resolvedIcon}
        </div>
      </div>
      <div
        aria-hidden="true"
        className="absolute border border-solid inset-0 pointer-events-none rounded-2xl"
        style={{ borderColor: colors.primary }}
      />
    </button>
  );
};


